import { type ReactNode } from 'react';

export type StartProps = {
  children?: ReactNode;
};

// Renders nothing because it's only used for footer placement verification on ./index.tsx
export const Start = (_props: StartProps) => {
  return null;
};
